import * as Sentry from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import version from './version';
import './i18n';
import { loadTrackingScriptsIfAllowed } from 'config/axeptio';
import { launchAxeptio } from 'config/tracking';

const root = document.getElementById('root');

if (!root) {
    throw new Error('Missing root element');
}

const { amplitudeApiKey, axeptioApiKey, hotjarApiKey, sentryDsn, environment, ...props } = root.dataset;

Sentry.init({
    dsn: sentryDsn,
    environment,
    release: version ? `mjb-frontend@${version}` : undefined,
});

if (environment === 'production') {
    launchAxeptio(axeptioApiKey);
    loadTrackingScriptsIfAllowed(amplitudeApiKey || '', hotjarApiKey || '');
}

createRoot(root).render(
    <React.StrictMode>
        <Sentry.ErrorBoundary fallback={<>An error has occurred</>}>
            <HelmetProvider>
                <App {...props} />
            </HelmetProvider>
        </Sentry.ErrorBoundary>
    </React.StrictMode>,
);
